import { Controller } from 'stimulus';
import { FetchRequest } from '@rails/request.js';
import { debounce } from '@/js/util';

export default class extends Controller {
  static targets = ['issueDate'];

  static values = {
    url: String,
    total: Number,
  };

  #abortController = null;

  connect() {
    this.refreshDebounced = debounce(this.refresh.bind(this), 300);
  }

  disconnect() {
    this.refreshDebounced.cancel && this.refreshDebounced.cancel();
    this.#abortController?.abort();
  }

  totalsChanged(event) {
    const total = Number(event.detail.total);

    if (total === this.totalValue) {
      return;
    }

    this.totalValue = total;
    this.refreshDebounced();
  }

  dateChanged() {
    this.refreshDebounced();
  }

  reveal() {
    const loaded = document.getElementById('installments');
    const ready = loaded ? Promise.resolve() : this.refresh();

    ready?.then(() => requestAnimationFrame(() => this.#scrollToSchedule()));
  }

  refresh() {
    if (!document.getElementById('installments-loader')) {
      return;
    }

    this.#abortController?.abort();
    this.#abortController = new AbortController();

    const request = new FetchRequest('get', this.urlValue, {
      responseKind: 'turbo-stream',
      query: this.#query,
      signal: this.#abortController.signal,
    });

    return request.perform().catch((error) => {
      if (error.name !== 'AbortError') {
        console.error(error);
      }
    });
  }

  #scrollToSchedule() {
    document
      .getElementById('installments-loader')
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  get #query() {
    return {
      'invoice[total]': this.totalValue,
      'invoice[issue_date]': this.issueDateTarget.value,
    };
  }
}
